import "./styles.css";
import React from "react";

const AboutMe = () => {
	return (
		<div className="aboutMe">
			<div className="aboutMeHeader">hey there</div>
			<div className="aboutMeInfo">
				<p className="aboutMeText">
					I&apos;m Valeria, a Frontend Developer. I focus on building functional
					interfaces that work well and look good, with attention to UX and
					design details.
				</p>
				<p className="aboutMeText">
					I care about being in a place that values diversity, equality, and
					inclusion. I&apos;m looking for an environment where I can keep
					growing, and where my skills and experience can make a real impact.
				</p>
				<p className="aboutMeText">
					Let me tell you more about myself and my work.
				</p>
			</div>
		</div>
	);
};

export default AboutMe;
